module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_DA-a15c5d0ef03b2bafe11eb38385c3720f.svg";